<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import settingsKeys from '../../../settings/settingsKeys.js';
    import { settingsGroupKeys } from '../pluginConfig.js';
    import Details from './generic/Details.svelte';
    import CheckMark from '../controls/generic/CheckMark.svelte';
    import PageZoomSetting from '../controls/PageZoomSetting.svelte';
    import { getIsNonDefaultState } from '../util.js';
    import { Icon } from '@oat-sa-private/ui-elements';
    import { __ } from '@oat-sa-private/ui-core';

    /**
     * Component of an a11y menu panel group
     */

    const groupKey = settingsGroupKeys.zoom;

    /**
     * @typedef {Object} Props
     * @property {Object} pluginConfig
     * @property {Object} initialSettingsState
     * @property {Function} onChange
     * @property {Function} onToggle
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        pluginConfig,
        initialSettingsState,
        onChange,
        onToggle
    } = $props();

    let nonDefault = $derived(getIsNonDefaultState(settingsKeys.pageZoom, initialSettingsState, pluginConfig));

    function handleChange(newState = {}) {
        nonDefault = newState?.state?.nonDefault;
        onChange?.(newState);
    }
</script>

<Details
    key={groupKey}
    config={pluginConfig[groupKey]}
    collapsed={initialSettingsState[groupKey]?.collapsed}
    outlined={nonDefault}
    ariaLabelCollapse={__('collapse zoom settings')}
    ariaLabelExpand={__('expand zoom settings')}
    {onToggle}>
    {#snippet summary()}
        <h3 class="ui-heading flex">
            <span>
                <Icon name="search-16" ariaHidden />
                {__('Zoom')}
                {#if nonDefault}
                    <CheckMark />
                {/if}
            </span>
            {#if pluginConfig[settingsKeys.pageZoom]?.enabled}
                <PageZoomSetting
                    config={pluginConfig[settingsKeys.pageZoom]}
                    initialState={initialSettingsState[settingsKeys.pageZoom]?.toolState}
                    onChange={handleChange} />
            {/if}
        </h3>
    {/snippet}
</Details>
